/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/ValidatedFormItem" />
import React = require("react");
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { InputValidationStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/InputValidationStore";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { FormItem, IFormItemProps } from "VSSUI/FormItem";
import { IValidationProps } from "./IValidationProps";

interface IValidatedFormItemProps extends IFormItemProps, IValidationProps {
    inputId: string;
}
interface IValidatedFormItemState {
    errorMessage: string;
    hasError: boolean;
}

export class ValidatedFormItem extends VssComponent<IValidatedFormItemProps, IValidatedFormItemState> {

    private readonly _validationStore: InputValidationStore;

    constructor(props: IValidatedFormItemProps, context: IVssComponentContext) {
        super(props, context);

        this._validationStore = StoreManager.GetStore<InputValidationStore>(InputValidationStore, props.validationScopeId);
        this._validationStore.addChangedListener(this._onStoreChange);

        this.state = {
            errorMessage: "",
            hasError: false
        };
    }

    public componentWillUnmount(): void {
        this._validationStore.removeChangedListener(this._onStoreChange);
    }

    public render(): JSX.Element {
        return (<FormItem {...this.props} message={this.state.errorMessage} error={this.state.hasError}>
            {this.props.children}
        </FormItem>);
    }

    private _onStoreChange = (): void => {
        const validationState = this._validationStore.getState();
        const message = validationState.errorDictionary[this.props.inputId];
        const sanitizedMessage = (!message || message === InputValidationStore.DefaultRequiredErrorMessage) ? "" : message;

        this.setState({
            errorMessage: sanitizedMessage,
            hasError: !!sanitizedMessage
        });
    }
}
